import { Commands } from "../../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../../vendor_core/core/src/commands/CommandManager";
import { UpdateBalanceCommand } from "../../../../vendor_core/core/src/commands/GameCommands";
import { ConfigurationTypes } from "../../../../vendor_core/core/src/const/ConfigurationTypes";
import PointerEvents from "../../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../../vendor_core/core/src/const/SoundVars";
import ConfigManager from "../../../../vendor_core/core/src/managers/ConfigManager";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../../vendor_core/core/src/model/BuyFeatureModel";
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import { UIComponents } from "../../../../vendor_core/core/src/ui/UIComponents";
import BuyFeaturePopups from "../../../../vendor_core/core/src/ui/popups/BuyFeaturePopup";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import { VendorCommandsEnum } from "../../../../vendor_core/src/commands/VendorCommandsEnum";
import Configs from "../../../../vendor_core/src/vendorConfigs/Configs";
import BuyFeatureConfig from "../../../configs/BuyFeatureConfig";


export default class TRWBuyFeaturePopups extends BuyFeaturePopups {

    public show(callback?: Function) {
        super.show(callback);

        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open").interactive = true;
    }
        
    protected setBetOptions = () => {
        /*
        slice all valid bets to bets witch we displayed on the Bet Settings example case 12
        */
        let bfConfig = Configs.buyFeature;
        let betConfig = Configs.bet;

        if (bfConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = bfConfig.getBetOptions();
        } else if (betConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = betConfig.getBetOptions();
        } else {
            BuyFeatureModel.validBets = [...BetModel.creditValues];
        }

        let idx: number = BuyFeatureModel.validBets.indexOf(BetModel.totalBet);
        BuyFeatureModel.currentBetIndex = idx > -1 ? idx : BuyFeatureModel.validBets.length - 1;
    }

    protected setInteractionOnClose = (callback?: Function) => {
        this.closeBtn.on(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            BuyFeatureModel.extraParams = [];
            ViewManager.getLayer(DefaultLayers.BetBarBottom)
            .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
            .value = BetModel.totalBet;

            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            this.hide();
        });
    }

    protected setInteractionOnPlay = () => {
        this.playBtn.on(PointerEvents.DOWN, () => {
            BuyFeatureModel.mode = 0;

            BuyFeatureModel.extraParams = [
                { "scatterBoost": false }
            ]
            BuyFeatureModel.hasBuyFeatureIsTriggered = true;

            const bfBet = BuyFeatureModel.getBet();
            const index = BetModel.creditValues.indexOf(bfBet)

            CommandManager.execute(Commands.SET_BET, {
                coinIndex: index,
                multiplier: undefined,
                value: bfBet
            });

            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            this.hide();

            CommandManager.execute(Commands.FEATURE_BUY_SPIN);
        })
    }

    protected setBet = () => {
        let bet = BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];
        if (bet) {
            this.betField.value = bet;
        }
    }

    protected incrementBet = () => {
        if (BuyFeatureModel.currentBetIndex < (BuyFeatureModel.validBets.length - 1)) {
            BuyFeatureModel.currentBetIndex += 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }

    protected decrementBet = () => {
        if (BuyFeatureModel.currentBetIndex > 0) {
            BuyFeatureModel.currentBetIndex -= 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }

    protected setTotalPrice = () => {

        // const index = BuyFeatureModel.currentBetIndex;
        // const betOptions = Configs.buyFeature.betOptions;
        // const divisor = BetModel.betDivisor;
        // const price = betOptions[index] / divisor * BuyFeatureConfig.creditPerBetBuyFeat;
        
        let config = Configs.buyFeature;
        let currentBet = BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];
        const price = config.betMultiplier[0] * currentBet

        this.totalPriceField.value = price;
        // this.checkBalanceEnoughForBuy(price); // TODO2: maybe change maxFeaturePurchasePrice
    }

    protected checkBalanceEnoughForBuy = (price: number) => {
        if (price <= Configs.buyFeature.maxFeaturePurchasePrice) {
            this.playBtn.setEnabled(true);
        } else {
            this.playBtn.setEnabled(false);
        }
    }

    protected betSync = () => {
        ViewManager.getLayer(DefaultLayers.BetBarBottom)
            .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
            .value = BuyFeatureModel.getBet();
    }
}
